import BooksService from '@/common/API/BooksService';
import { FormUtils } from '@/common/FormUtils';
import { useData } from '@/common/hooks/useData';
import { genresList } from '@/common/static/genresList';
import FormFactory from '@/components/FormFactory';
import FileUpload from '@/components/forms/FileUpload';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { Button } from '@/components/ui/button';
import { Field } from 'formik';
import { MutableRefObject, useEffect, useRef } from 'react';

const BooksEditScreen = ({ onSuccess, id }: { onSuccess: () => void; id: string }) => {
  const formRef: MutableRefObject<any> = useRef();
  const { authors, fetchBooks } = useData();

  useEffect(() => {
    BooksService.one(id).then((res) => {
      formRef.current.setValues(res.data);
    });
  }, []);

  return (
    <main>
      <FormFactory formRef={formRef} initialValues={{ name: '', genre: '', author_id: '', image: '' }}>
        <Field
          name='image'
          uploadContainerClass=' my-3'
          containerClassName='w-1/3 mx-auto'
          placeholder='Image'
          component={FileUpload}
        />
        <Field name='name' placeholder='Book name' component={Input} />
        <Field name='genre' options={genresList} placeholder='Select genre' component={Select} />
        <Field name='author_id' options={authors} placeholder='Select author' component={Select} />
      </FormFactory>
      <Button
        onClick={() => {
          const fd = FormUtils.generateFormData(formRef.current.values, ['image']);
          BooksService.update(id, fd).then((res) => {
            fetchBooks();
            onSuccess();
          });
        }}
        className='w-full mt-4'
      >
        Submit
      </Button>
    </main>
  );
};

export default BooksEditScreen;
